export const mailTo = (email, subject, body) => {
  const mailTo = `mailto:${email}?subject=${subject}&body=${body}`;
  return mailTo;
};
